import { useContext, useEffect } from "react";
import { CarCompetitionData } from "../contextProvider";
import DOMPurify from "dompurify";

const SpecsModalContent = () => {
  const { secondarySectionPopupHtml } = useContext(CarCompetitionData);

  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  return (
    <div className="flex flex-col max-h-[70vh] h-full py-6">
      <div className="min-h-0 flex-1 overflow-y-auto">
        {secondarySectionPopupHtml ? (
          <div
            className="text-[#4C4C52] text-sm leading-5 [&_p]:mb-0 [&_h1]:leading-7 [&_h2]:leading-7 [&_h3]:leading-7"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(secondarySectionPopupHtml) }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default SpecsModalContent;
